import { compose, withProps, defaultProps } from "recompose";
import yup from "yup";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { withRouter } from "react-router-dom";
import { createErrorsSelector } from "core/helpers";
import * as mixpanel from "core/integrations/mixpanel";
import * as fbPixel from "core/integrations/fb_pixel";
import * as dataLayer from "core/integrations/gtm";
import { withHOC } from "core/react/hoc";
import View from "./View";

export default withHOC(props =>
  compose(
    withRouter,
    connect(
      createStructuredSelector({
        errors: createErrorsSelector(props.submitApiSelector),
        sendInviteApi: props.submitApiSelector
      }),
      {
        onSubmit: ({ ...values }) => {
          mixpanel.trackEvent(props.invitationEvent, {
            emails: values.emails
          });
          fbPixel.fbq("trackCustom", props.invitationEvent);
          dataLayer.push({
            event: props.invitationEvent
          });
          return props.submitReferralApi.request({ body: values.emails });
        }
      }
    ),
    defaultProps({
      title: props.title
    }),
    withProps({
      initialValues: { emails: [{ invitee_email: "" }] },
      validationSchema: yup.object().shape({
        emails: yup.array().of(
          yup.object().shape({
            invitee_email: yup.string().email("Is not valid email")
          })
        )
      })
    })
  )
)(View);



// WEBPACK FOOTER //
// ./src/components/common/referral/SendReferral/Provider.js